import useSWRMutation, { SWRMutationConfiguration } from 'swr/mutation';

export type UseMutationHandler<T, TArg = undefined> = (arg: TArg) => Promise<T>;

export type UseMutationProps<T, TError extends Error> = Pick<
  SWRMutationConfiguration<T, TError>,
  'onSuccess' | 'onError'
> & {
  namespace?: string;
  tags?: string[];
};

export function useMutation<TReturn, TArg, TError extends Error = Error>(
  key: string | null,
  handler: UseMutationHandler<TReturn, TArg>,
  props: UseMutationProps<TReturn, TError> = {}
) {
  const { namespace = 'domain', tags, ...others } = props;

  const { data, isMutating, error, trigger, reset } = useSWRMutation(
    { namespace, tags, key },
    (_, { arg }) => handler(arg as TArg),
    others
  );

  return [
    { data: data || null, error: error || null, submitting: isMutating, reset },
    trigger,
  ] as const;
}
